import DefaultPage from 'legacy/pages/DefaultPage'
import $ from 'legacy/vendor/jquery.custom'
import addBootstrapTab from 'legacy/vendor/jquery/bootstrap/tab'

import {
  Chart,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js'

export default class AreaStatsPage extends DefaultPage {
  static mount() {
    super.mount()

    addBootstrapTab($)
  }

  static initialize() {
    super.initialize()

    this.$barChart = $('#js-area-stats-bar-chart')
    if (this.$barChart.length) this.renderBarChart()
  }

  static renderBarChart() {
    Chart.register(
      BarElement,
      BarController,
      CategoryScale,
      LinearScale,
      Tooltip,
    )

    // eslint-disable-next-line no-new
    new Chart(this.$barChart, {
      type:    'bar',
      data:    this.$barChart.data('stats'),
      options: {
        maintainAspectRatio: false,
        scaleShowGridLines:  true,

        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            beginAtZero: true,
            title: { display: true, text: 'Homes sold' },
          },
        },
      },
    })
  }
}
